import { render, staticRenderFns } from "./ForecastingStockHtmlTemplate.vue?vue&type=template&id=7280418c&scoped=true"
import script from "./ForecastingStockHtmlTemplate.vue?vue&type=script&lang=js"
export * from "./ForecastingStockHtmlTemplate.vue?vue&type=script&lang=js"
import style0 from "./ForecastingStockHtmlTemplate.vue?vue&type=style&index=0&id=7280418c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280418c",
  null
  
)

export default component.exports